/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-20 14:30:59
 * @Description:
 */
import { sSiteName } from '@/utils/constant';

// ▼首页标题
const gameTitle = {
    Hot:'Hot',
    New:'New',
    Test: 'Beta',
    Playing:'Playing',
    OnlineUsers:'Online users',
    JackpotAmount:'Jackpot Amount',
    FrequentlyPlaying: 'Frequently Playing',
    PopularGames: 'Popular Games',
}
// ▼控制游戏下注等
const gameControl = {
    Manaual: 'MANUAL',
    Auto: 'AUTO',
    AutoDialogTitle: 'Automatic betting rule settings', // 自动投注策略设置
    Strategies: 'Strategies',
    Min: 'Min',
    Max: 'Max',
    BetAmount: 'Bet Amount',
    Amount: 'Amount',
    CashoutAt: 'Cashout at',
    Bets: 'Bets',
    MinBet: 'Min Bet',
    MaxBet: 'Max Bet',
    Bet: 'Bet',
    StartPlaying: 'Start playing',
    BetStart: 'Start',
    BetStop: 'Stop',
    customAmount: 'Input',
    ...{
        // 以下内容用于自动模式的输入面板（弹窗）中
        NUMBER_OF_BETS: 'NUMBER OF BETS',
        STOP_ON_PROFIT: 'STOP ON PROFIT',
        STOP_ON_LOSS: 'STOP ON LOSS',
        MAX_BET_AMOUNT: 'MAX BET AMOUNT',
        ON_WIN: 'ON WIN',
        ON_LOSS: 'ON LOSS',
        Reset: 'Reset',
        Increase: 'Increase',
    },
    ...{
        // 与上面内容重复，用处不明 
        MaxBetAmount: 'Max bet amount',
        StopOnLoss: 'Stop on loss',
        NumberOfBets: 'Number of bets',
        StopOnProfit: 'Stop on profit',
        OnWin: 'On win',
        OnLoss: 'On loss',
    },
};



// 👇 用于菜单与按钮（先放在此类，逐步优化）
const menuAndBtn = {
    rank: 'Rank',
    wallet: 'Wallet',
    unableChange: "Can't change currency during autoplay",
    version: 'Version',
};

// ▼历史记录
const history = {
    USER: 'User',
    deposit: 'Deposit',
    withdraw: 'Withdrawal',
    inAndOut: 'All',
};

// ▼分享
const ShareBtn = {
    Share: 'Share',
    ShareTitle: `Good job! Share this with friends on social networks. Play more and get new achievements on ${sSiteName}.`,
    Section1: 'This post will not take part in the Share & Win competition.',
    AboutShareAndWin: 'About Share & Win',
    Message: 'Message',
    Section2: `Hey guys! I want to share this win with you. I’m so happy to earn it on ${sSiteName}.`,
    BetCorgiChat: `${sSiteName} Chat`,
    Twitter: 'Twitter',
    Telegram: 'Telegram',
    MyWin: 'My Win',
    MyWinTextIcon: 'My Win 🎉',
};

// ▼游戏 SpaceDice 相关
const GameSpaceDice = {
    SpaceDiceRule1: 'Select a value range by moving the slider and place your bet, you win if the generated lucky number falls within that range.',
    ChooseNumber: 'CHOOSE NUMBER',
    Low: 'Low',
    High: 'High',
};

// ▼游戏 Dice 相关
const GameDice = {
    'ruleText': 'Select a predicted value by moving the slider and place your bet, you win if the generated lucky number is less than the predicted value.',
    Prediction: 'Prediction',
    LuckyNumber: 'Lucky Number',
};

const GameRing = {
    Segments: 'SEGMENTS',
    ringRule1: 'Select the risk level and place your bet. If the pointer stops at the corresponding multiple area, you will win the corresponding multiple bonus.',
};

const GameCryptos = {
    CryptosRule1: 'Among the five currencies, the more the same currency appears, the higher the odds.',
};

const GameTower = {
    AutoPick: 'AutoPick',
    Cleartable: 'Clear table',
    Rule1: 'Choose the number of demons and place your bet, click on the grid from bottom to top, avoid the demons and win a 10,000x bonus.',
    Devilkins: 'Devilkins',
    DevilkinsNums: 'Number of devilkins',
};

const GameStairs = {
    Rule1: 'Choose the number of stones that fall and place your bet, climb the ladder to avoid the stones, the higher you climb the higher the reward.',
};

const GameBlackJack = {
    PerfectPairs: 'Perfect Pairs',
    TotalBet: 'Total Bet',
    Hit: 'Hit',
    Stand: 'Stand',
    Split: 'Split',
    Double: 'Double',
    Insurance:
        'Accept to place half of the ante bet, if the dealer has natural blackjack, insurance pays 2:1',
    SidebetWin: 'Side bet win',
    SideBetInfo: 'Side bet info',
    PerfectPair: 'Perfect pair',
    ProMode: 'Pro Mode',
    handCard: 'Hand',
    betsList: 'Bets list',
    anteBet: 'Ante Bet',
    insuranceItem: 'Insurance', 
    cannotChange: 'Cannot switch mode during gameplay', 
    ruleText: `
        1. 8 standard 52 cards decks are in play each round
        2. Only when the dealer reveals an Ace face card is the optional side bet known as insurance available.
        3. The outcome is a push if both the player and the dealer have natural blackjack. Bet will be returned to the player in this case.
        4. If the dealer has a natural blackjack, the game is over and any taken insurance is paid.
        5. Blackjack pays x2.5, Insurance pays x2, standard pays x2. 
        6. Only one split is permitted.
        7. On a split aces, you cannot hit.
        8. On either of the first two cards, you can double.
        9. On a split, you can double.
        10. Dealer stands on all 17’s.
        11. Max bet limit applies to the whole game round, which means that some of the actions (Split/Double) might not be available in this case.
    `.trim().replace(/ *\n */g, '\n'), 
    ruleDesc01: "Win by getting cards as close to and no more than 21 points and beating the dealer's points.",
    // ruleDesc02: 'Then you can additionally take more cards or stop and stay with the current hand',
    // ruleDesc03: 'By clicking "Double", you double the bet and take only one more card to your hand',
    // ruleDesc04: 'When you get 2 cards of the same value, you can click "Split", your bet will be doubled and you will continue playing on two hands',
    // ruleDesc05: `Insurance is only available when the dealer's first card is an ace, insurance cost is half of your main bet`,
    // ruleDesc06: 'The winner is the one who is closer to 21. If you and the dealer get the same values - there will be a push',
    bust: 'Bust',
    // ↓ 这些是 pro 模式弹出窗口中的内容  
    tryNew21Title01: 'Try the Pro Blackjack Mode featuring two new Side Bets', 
    tryNew21Title02: 'Place your standard Ante Bet to be able to add Side Bets to the game round:', 
    secondtion01Desc: 'Perfect Pairs is a side bet that the first two cards the player is dealt make a pair, with three different types of pair paying out at different odds', 
    secondtion02Title: '21+3',
    secondtion02Desc: 'In the 21+3 blackjack side bet you bet on whether the first two cards of your hand and the dealer’s face - up card combine to make one of the three - card poker hands',
};


// 👇自动模式弹出的窗口的内容
const AutoModeRemeder = {
    AutoModeBigTitle: 'Automatic betting rule description',
    AutoModeTitle: 'Set the parameters and the system will automatically place the bets for you.',
    AutoModeSection1: 'Parameter Description',
    // ↑ 大小标题 
    // ↓ 以上是对自动模式弹出的输入面板的输入框做说明 
    NumberOfBetsDescription: 'Set the total number of bets for the automatic mode.',
    StopOnProfitDescription: 'Stop the automatic mode after reaching the profit target.',
    StopOnLossDescription: 'Stop the automatic mode after reaching the loss amount.',
    MaxBetAmountDescription: 'Set the maximum bet amount for a single bet.',
    OnWinDescription: 'Reset to reset the betting amount to the initial betting amount after winning the game, and raise to increase the betting amount after winning the game.',
    OnLossDescription: 'Reset to reset the betting amount to the initial betting amount after losing the game, and increase the betting amount after losing the game.',
};

// 👇Fairness 公平性相关信息
const Fairness = {
    Fainess: 'Fairness',
    FainessContent:
        'A provably fair system based on the SHA256 algorithm and includes a random number = a combination of a random winning number and the initial number of the server. Each round has its own hash, consisting of random wins that are uniquely generated for each bet.',
    Check: 'Check',
    HowItWorks: 'How it works',
    PreviousRoundsHistory: 'Previous rounds history',
    HashRound: 'Hash round',
    RandomSeed: 'Random seed',
    RoundSeed: 'Random seed',
    FainessMobileContent: "This game uses the SHA256 algorithm to ensure the fairness of the game and to ensure that the game's lottery results are random and cannot be manipulated.",
    MobileHashRound: 'Current hash round',
    FairnessPrinciple: 'Principle',
    gameName: 'Game name',
    PrincipleContent: 'The game uses the same SHA256 technology as Bitcoin to ensure the fairness of the game.',
    PrincipleContentBefore: '1. Before placing a bet, you can click on the current hash value in the "Fairness" pop-up window. This hash value is like a lock, which is generated by a random seed, and this random seed is the key. In other words, once the hash value (lock) is announced, the lottery result (key) is determined and cannot be changed, thus ensuring the fairness of the game.',
    PrincipleContentAfter: '2. After placing the bet, you can copy the random seed (key), go to the third-party page to generate a hash value (lock), and check whether this hash value (lock) is consistent with the previous hash value (lock).',
};

const GameDetails = {
    BetDetails: 'Bet Details',
    By: 'By',
    BetCorgi: sSiteName,
    Player: 'Player',
    Date: 'Date',
    BetId: 'Bet ID',
    PlayGame: 'Play Game',
    CheckFairness: 'Check Fairness',
    CopyLink: 'Copy Link',
    CopyMessageTitle: 'Copied',
    CopyMessage: 'The link is copied successfully',
    UserProfile: 'User Profile',
};
const roundDetails = {
    roundDetail: 'Round Details',
    RoundID: 'Round ID',
    Result: 'Result',
    RandomSeed: 'Random Seed',
}

const UserProfile = {
    UserProfile: 'User Profile',
    Activity: 'Activity',
    Statistics: 'Statistics',
    LeaveATip: 'Leave a tip',
    TopPlayedGames: 'Top played games',
    TournamentsAndBattlesReward: 'Tournaments & Battles Reward',
    TotalBets: 'Total bets',
    EarnedStaking: 'Earned Staking',
    TotalWagered: 'Total wagered',
    TotalTips: 'Total tips',
    TotalRains: 'Total rained',
    TotalCoindrops: 'Total coindrops',
    Wagered: 'Wagered',
    ChatActivityDetails: 'Chat Activity details',
    DaysOnThePlatform: 'days on the platform',
    TotalMessages: 'Total Messages',
    LikesReceived: 'Likes Received',
    Coindrops: 'Coindrops',
    Rains: 'Rains',
    CryptoFutures: 'Crypto Futures',
    TotalWin: 'Total Win'
};

// 游戏规则
const gameRules = {
    plinkoRule1:
        'After placing a bet, the ball drops, and the bonus multiple is determined based on the different locations where the ball finally lands.',
    limboRule1: 'Predict the flight distance, if the flight exceeds the predicted distance, you win.',
    coinflipRule1: 'Choose heads or tails and win if the result matches your choice.',
    corgiwildRule1: 'Spin the reels and match the same symbols to win bonuses.',
    corgiwildPaylinesRule: 'Corgi Wild has one payline active',
    corgiwildPayTableRule: 'All wins shown as a multiple of the active Coin Size',
    any1: 'any 1',
    any2: 'any 2',
    any3: 'any 3',
    wild: 'WILD',
    corgiwildPayTableDesc1: 'substitules for any symbol, with wins multiplied.',
    corgiwildPayTableDesc2: 'Mixed Furies',
    startPlaying: 'Start playing',
    circleRule1:
        'Bet on different colors and win corresponding multiples of bonuses based on the color the wheel finally stops on.',
    tripleRule1: 'Select 3 squares and place your bet. Scratch out a combination of 3 winning areas to win the corresponding multiple of the prize.',
};

// 游戏右下角的几个控制按钮
const gameSettingBar = {
    Animate: 'Animate',
    Fast: 'Fast',
    Statistics: 'Statistics',
    Rules: 'Rules',
    Settings: 'Settings',
};

// 游戏名
const gameNames = {
    Dice: 'Dice',
    SpaceDice: 'Space Dice',
    Limbo: 'Limbo',
    Plinko: 'Plinko',
    CoinFlip: 'CoinFlip',
    Keno: 'Keno',
    Crash: 'Crash',
    Mines: 'Mines',
    Ring: 'Ring',
    Cryptos: 'Cryptos',
    Tower: 'Tower',
    HiLo: 'HiLo',
    Stairs: 'Stairs',
    Circle: 'Circle',
    Triple: 'Triple',
    Roulette: 'Roulette',
    Blackjack: 'Blackjack',
    RedPacket: 'RedPacket',
    Niuniu:'Bull Bull For 100',
    BullfightPoker: 'BullFightPoker',
    Zhajinhua: 'Zhajinhua',
    Jisuzhajinhua: 'Jisuzhajinhua',
    BetCorgiOriginals: 'BetCorgi Originals',
    // -- ↓ corgi 系列  -------------------------- 
    Futures: 'Futures',
    CorgiWild: 'CorgiWild', 
    Pharaoh: 'CorgiPharaoh',
    CorgiPharaoh: 'CorgiPharaoh',
};


const plinkoI18n = {
    winAmount: 'Win Amount',
    chance: 'Chance',
    risk: 'RISK',
    rows: 'ROWS',
    maxPayout: 'Max payout is'
};

const limboI18n = {
    target: 'TARGET',
};

const coinflipI18n = {
    betHead: 'BEAT HEAD',
    betTail: 'BEAT TAIL',
    bet: 'BET',
    instant: 'Instant',
    multiply: 'Multiply',
    profit: 'Profit',
    series: 'series',
    multiplier: 'multiplier',
    win: 'win',
    lose: 'lose',
    cashout: 'cashout',
    firstSide: 'First side'
};

// 用于游戏规则弹出窗口
const gamePlayingRule = {
    howToPlay: 'How to play',
    rules: 'Rules',
    payTable: 'PayTable',
    payLines: 'Paylines',
    Limits: 'Limits',
    howDoesGameStart: 'How to play',
    payouts: 'Payouts',
    payoutsName: 'Name',
    payoutsValue: 'Payouts',
};

const circleI18n = {
    hash: 'Hash',
    random: 'Random',
    placeBet: 'PLACE YOUR BETS',
    showResult: 'SHOW RESULT',
    stopBet: 'STOP PLACING BETS',
    nextRound: 'PREPARING NEXT ROUND',
    autoBet: 'Auto',
    startAuto: 'Start Auto',
    stopAuto: 'Stop Auto',
    red: 'Red',
    gray: 'Gray',
    yellow: 'Yellow',
    green: 'Green',
    myBet: 'My Bet',
    winner: 'Winner',
    otherJackpots: 'Other Jackpots',
    betAmountTips: 'Insufficient balance, auto bet disabled',
};



const tripleI18n = {
    autoPick: 'Auto Pick',
    clearPick: 'Clear Table',
};



// ↓ 分类不明，暂时集合在此，慢慢分类
const noClear = {
    Casino: 'Casino',
    Favorites: 'Favorites',
    Recent: 'Recent',
    Battle: 'Battle',
    VampireOriginals: 'Vampire Originals',
    Multiplier: 'Multiplier',
    ProfitOnWin: 'Profit on win',
    Chancetowin: 'Chance to win',
    Menu: 'Menu',
    Search: 'Search',
    Contests: 'Contests',
    Chat: 'Chat',
    Game: 'Game',
    Time: 'Time',
    Payout: 'Payout',
    PricePool: 'Price Pool',
    MyBFG: 'My BFG',
    AUCTIONBFG: 'AUCTION BFG',
    Rating: 'Rating',
    GameRules: 'Game rules',
    Next: 'Next',
    History: 'History',
    AllPlayers: 'All players',
    MaxPayout: 'Max Payout',
    VIPUser: 'VIP User',
    LiveChart: 'Live Chart',
    Battles: 'Battles',
    All: 'All',
    Profit: 'Profit',
    Prize: 'Prize',
    Wagered: 'Wagered',
    Wins: 'Wins',
    Losses: 'Losses',
    FinishIn: 'Finish in',
    YourPrice: 'Your price',
    Note: 'Note!',
    DonNotshowThisAgain: 'Don’t show this again',
    Continue: 'Continue',
    Noinformation: 'No information',
    Tournaments: 'Tournaments',
    Price: 'Price',
    Date: 'Date',
    BattleName: 'Battle Name',
    Place: 'Place',
    Detail: 'Detail',
    Years: 'years',
    Months: 'months',
    Days: 'days',
    CashOut: 'Cash Out',
    Copied: 'Copied',
    Create: 'Create',
    Cancel: 'Cancel',
    OK: 'OK',
    AreYouSure: 'Are you sure?',
    Save: 'Save',
    No: 'No',
    Accept: 'Accept',
    ExitToLobby: 'Exit to Lobby',
    ID: 'ID',
    RoundId: 'Round ID',
    payout: 'Payout',
    winningAmount: 'Payout',
    Congratulations: 'Congratulations!',
    youWin: 'you win!',
    Type: 'Type',
    State: 'State',
    Redeemed: 'Redeemed',
    Redeeming: 'Redeeming',
    StonesNumber: 'Stones',
    FastMode: 'Fast Mode',
    FastModeNitify: 'Fast Mode is available only in Auto game Mode.',
    FastModeDisabled: 'Prohibit switching modes while gaming',
};

const liveChatI18n = {
    chatWagered: 'Wagered',
    chatWin: 'Wins',
    chatLoses: 'Loses',
}

// ↓ 在上方导航中弹出的用户菜单
const userMenuInHeader = {
    MyProfile: 'My Profile',
    Account: 'Account',
    TransactionHistory: 'Transaction History',
    GameHistory: 'Game History',
    Sessions: 'Sessions',
    Vault: 'Vault',
    Verification: 'Verification',
};

// ↓用户 session 管理页使用 
const sessionPage = {
    statusActive: 'Active',
    statusCurrent: 'Current',
    date: 'Date',
    browser: 'Brower',
};

// ↓ 公共的，多处使用的内容
const commonInfo = {
    Animation: 'Animation', 
    error: 'Error', // 错误
    info: 'Info',
    tips: 'Tips',
    success: 'Success',
    coefficient: 'Coefficient',
    // ↓ 用于弹出的一些消息内容 
    ...{
        noBacking: 'Not allowed back from home page.',
        newTabGaming: 'You have opened current game in a new tab, the current page is invalid.',
        hasLoadedLastRound: 'The previous game has been loaded',
        currencyChangedFailed: 'Currency switching unsuccessful', 
        currencyChangedTo: 'The currency has been switched to:', // USD
        currencyChangedDesc: 'You have switched currency at other page, it has been synchronized to this page. The "auto mode betting" of the game will also be stopped (if any)',
        userOffLineTitle: 'The account has been logged out.',
        userOffLineDesc: 'Your login has expired. Please log in again.',
        badNetwork: 'Network connection is abnormal. Please check your network link, or refresh the page',
        wsConnecting: 'Network instability, attempting to reconnect {percentage}%',
        wsRestored: 'Network restored',
        networkInstability: 'Network instability',
        attemptingReconnect: 'attempting to reconnect',
        tokenNoValid: 'Login status is expired or no longer valid. Please log in again.',
        requestTimeout: 'Request timeout {info}', // 传入接口地址，或其它   
        requestError: 'Request error',
        locked: 'Account frozen. Contact support'
    },
    ...{ // 主要用于按钮 
        goBack: 'Back',
        refresh: 'Refresh',
        close: 'Close',
        confirm: 'OK',
        confirmBtn: 'Confirm',
        goHomePage: 'Go home page',
        restRound: 'Rest',
    },
    // ↓ 用于在【信息页】显示的一些内容 
    ...{
        notLoggedIn: 'Not Logged In', // 用于未登录页面
        logInFailed: 'Login unsuccessful',
        connectionFailed: 'Websocket connection not successful',
        pageNotFound: 'Page not found',
    },
    ...{ // 下注时提示金额不正确等提示
        noBlance: 'Insufficient balance to place bets',
        lackOfBlance: 'Insufficient balance, auto betting has stopped',
        amountTooLess: 'Please enter the correct amount, the current currency betting minimum is {min}',
        amountTooMuch: 'Please enter the correct amount, the current currency betting maximum is {max}',
        payoutOverLimit: 'Warning: max payout is {limit}', // limit 应传入数字+单位 
    },
    ...{ // 风险等级 
        riskLow: 'Low',
        riskMedium: 'Medium',
        riskMediumHigh: 'Medium-High',
        riskHigh: 'High',
    },
    userId: 'User ID',
    userName: 'User name',
};


const amountTips = {
    'noMoneyPleaseCharge': 'Insufficient balance, please recharge', 
    'reachedLowerLimit': 'The minimum betting amount has been reached', 
    'reachedUpperLimit': 'The maximum betting amount has been reached', 
    'reachedUserBalance': 'The user balance has been reached',
}


// ↓ 将国际化信息在上方分类，后再注入到下方，以使分类清晰
export default {
    error: commonInfo.error, // 本应调用 t.commonInfo.error 但多处在调用 t.error 和 $t('error')，所以补充这项，用于容错
    ...gameControl,
    ...GameSpaceDice,
    ...history,
    ...AutoModeRemeder,
    ...Fairness,
    ...gameRules,
    ...gameSettingBar,
    ...gameNames,
    ...plinkoI18n,
    ...limboI18n,
    ...coinflipI18n,
    ...noClear,
    ...gamePlayingRule,
    ...circleI18n,
    ...tripleI18n,
    ...liveChatI18n,
    ...roundDetails,
    GameStairs,
    GameTower,
    GameCryptos,
    GameRing,
    UserProfile,
    GameDice,
    ShareBtn,
    menuAndBtn,
    GameDetails,
    GameBlackJack,
    commonInfo,
    userMenuInHeader,
    sessionPage,
    gameTitle,
    amountTips,
};
